import { useState, useEffect, useCallback } from 'react';
import { axiosApi } from '../../api/setupApi';

function useNisFsResult(year) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchNisFsResult = useCallback(async () => {
    if (!year) return;
    setLoading(true);
    setError(null);

    try {
      const { data } = await axiosApi.get(`/nisfsResult/nested/${year}`);
      setData(data);
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  }, [year]);

  useEffect(() => {
    fetchNisFsResult();
  }, [fetchNisFsResult]);

  return { data, loading, error, refetch: fetchNisFsResult };
}

export default useNisFsResult;
